<template>
  <div class="min-h-screen">
    <router-view />
  </div>
</template>

<script setup>
// Simple guest layout - just a wrapper for guest pages
// Background is handled by each page individually
</script>